import React, {Component} from 'react'
// import {DropzoneArea} from 'material-ui-dropzone',
import { useDropzone } from 'react-dropzone';
 
class Dropzone extends Component{
  constructor(props){
    super(props);
    this.state = {
      files: []
    };
  }
  handleChange(files){
    this.setState({
      files: files
    });
  }
  render(){
    return (
      <useDropzone 
        onChange={this.handleChange.bind(this)}
        />
    )  
  }
} 
 
export default Dropzone;